import SiteMessagesInstance from '../components/site-messages'

class RequestQueue {

  constructor() {

    if (!RequestQueue.instance) {
      this.queue = this.load();
      this.isRunning = false;
      RequestQueue.instance = this;
    }

    // run queue whenever online
    window.addEventListener('online', this.run.bind(this));

    return RequestQueue.instance;

  }

  // Function to add a request to the queue
  add(endpoint, data) {

    this.queue[endpoint] = { endpoint, data };
    console.log(`Request added: ${endpoint}`, {data});

    this.save();

  }

  // Function to run the requests in the queue sequentially
  async run() {

    if(this.isRunning) {
      return;
    }

    this.isRunning = true;

    while (Object.keys(this.queue).length > 0) {

      // Get the first key from the object queue
      const endpointKey = Object.keys(this.queue)[0];
      const { endpoint, data } = this.queue[endpointKey];

      try {
        console.log(`Processing request: ${endpoint}`, {data});

        let response = await window.apiRequest('post', endpoint, data);

        console.log(`RequestQueue: ${endpoint}:`, response);

        // Remove the processed request from the queue
        delete this.queue[endpointKey];
        this.save();

      } catch (error) {
        console.error(`RequestQueue: ${endpoint}:`, error);

        // Break out of the loop to retry this request later
        this.save();
        break;
      }
    }

    this.isRunning = false;

  }

  // Save the current queue to localStorage
  save() {
    try {
      localStorage.setItem('requestQueue', JSON.stringify(this.queue));
      console.log('Queue saved to localStorage', this.queue);
    } catch (error) {
      console.error('Error saving queue to localStorage:', error);
    }
  }

  // Load the queue from localStorage
  load() {
    try {
      const savedQueue = localStorage.getItem('requestQueue');
      return savedQueue ? JSON.parse(savedQueue) : {};
    } catch (error) {
      console.error('Error loading queue from localStorage:', error);
      return {};
    }
  }

}

const RequestQueueInstance = new RequestQueue();

export default RequestQueueInstance;
